import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="translate--content"
export default class extends Controller {
  static values = {
    key: String,
    language: { type: String, default: "en" },
  }

  connect() {
    this.isEnglish = this.languageValue === "en"
    this.englishKey = `content-en-${this.keyValue}`

    if (this.isEnglish) {
      this.englishContent = this.element.innerHTML.trim()
      this.cloneContent(this.englishContent)
    } else if (this.orignalContent) {
      this.englishContent = this.orignalContent.innerHTML
    }
  }

  async translate(event) {
    const { targetLanguage } = event.detail

    if (targetLanguage === this.languageValue) {
      return
    }

    if (!this.englishContent) {
      console.error(this.keyValue, "Missing original english text!")
      return
    }

    if (targetLanguage === "en") {
      this.element.innerHTML = this.englishContent
      return
    }

    let formData = new FormData()
    formData.append("lesson_id", this.keyValue)
    formData.append("target_language", targetLanguage)
    formData.append("contents[]", this.englishContent)

    try {
      const response = await fetch("/api/v2/translations/translate.json", {
        body: formData,
        method: "post",
      })
      const { translations } = await response.json()
      this.element.innerHTML = translations[0]
      this.languageValue = targetLanguage
    } catch (error) {
      console.error(error)
    }
  }

  cloneContent(content) {
    if (this.orignalContent) {
      return
    }

    const clone = document.createElement("script")
    clone.setAttribute("id", this.englishKey)
    clone.setAttribute("type", "text/template")
    clone.innerHTML = content
    document.body.appendChild(clone)
  }

  get orignalContent() {
    return document.getElementById(this.englishKey)
  }
}
